import React from "react";
import { twMerge } from "tailwind-merge";

type HeadingSectionProps = {
  title: string;
  titleColor?: string;
  description?: string;
  descriptionColor?: string;
  className?: string;
};

const CustomHeader: React.FC<HeadingSectionProps> = ({
  title,
  titleColor,
  description,
  descriptionColor = "text-white",
  className,
}) => {
  return (
    <div className={`space-y-6 mx-auto ${className}`}>
      <h2
        className={twMerge(
          `text-3xl font-bold tracking-tighter sm:text-4xl md:text-5xl ${titleColor}`
        )}
      >
        {title}
      </h2>
      <p
        className={`max-w-[600px] md:text-xl/relaxed lg:text-base/relaxed xl:text-xl/relaxed ${descriptionColor} mx-auto`}
      >
        {description}
      </p>
    </div>
  );
};

export default CustomHeader;
